<div class="flex items-center">
	<div
		class="border h-[58px] w-0"
		[ngClass]="{
			'border-green-500': data.borderStatusColor === 'green',
			'border-red-500': data.borderStatusColor === 'red'
		}"
	></div>
	<div class="flex items-center justify-between border-r-[#394655] border-y-[#394655] border-y border-r pl-3 pr-5 py-4">
		<div class="flex items-center">
			<img src="assets/svg/{{ data.iconStatusColor === 'green' ? 'check-green' : 'error' }}.svg" alt="" class="mr-3" />
			<div class="text-[14px]" [innerHTML]="data.html"></div>
		</div>
		<mat-icon class="text-white ml-12 cursor-pointer" (click)="snackBar.dismiss()">close</mat-icon>
	</div>
</div>
